import {post, get} from '../http'

export function post_login (data) {
  return post('web/tcUser/login', data)
}
// 重置密码
export function post_resetPassword (data) {
  return post('web/tcUser/resetPassword', data)
}
// 注册
export function post_userRegister (data) {
  return post('web/tcUser/userRegister', data)
}
// 账户 密保验证
export function post_validateAccountOrPassword (data) {
  return post('web/tcUser/validateAccountOrPassword', data)
}
// 账户中心 修改密码
export function postPersonalChangePassword (data) {
  return post('web/personal/changePassword', data)
}
// 问题反馈
export function postPersonalFeedback (data) {
  return post('web/personal/feedback', data)
}
// 账户信息查询
export function getPersonalSelectAccountInformation (data) {
  return get('web/personal/selectAccountInformation', data)
}

// 消息中心
export function postPersonalMessageCenterList (data) {
  return post('web/personal/messageCenterList', data)
}
// 消息详情
export function getPersonalselectMessageCenterDetail (id) {
  return get('web/personal/selectMessageCenterDetail/' + id)
}
// 删除消息
export function postPersonalDeleteMessageCenter (data) {
  return post('web/personal/deleteMessageCenter', data)
}
// 未读消息统计
export function getPersonalSelectMessageCenterStatistics (data) {
  return get('web/personal/selectMessageCenterStatistics', data)
}
//全部已读
export function postPersonalallReadMessageCenter (data) {
  return post('web/personal/allReadMessageCenter', data)
}

// 下载图片 转流文件
export function getfileDownload (key) {
  return get('web/file/download/' + key)
}



// WEBPACK FOOTER //
// ./src/api/modules/login.js